import { render, staticRenderFns, recyclableRender, components } from "./u-navbar.vue?vue&type=template&id=95dec1ae&scoped=true&"
var renderjs
import script from "./u-navbar.vue?vue&type=script&lang=js&"
export * from "./u-navbar.vue?vue&type=script&lang=js&"
import style0 from "./u-navbar.vue?vue&type=style&index=0&id=95dec1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dec1ae",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-navbar/u-navbar.vue"
export default component.exports